import { ContrastColor } from 'common/colorContrast'

import { useListBrandTokensQuery } from './useBrandTokens'
import { useRoomDesign } from './useRoomDesign'

const BRAND_COLOR_TOKEN_PREFIX = 'brand:color:'

const useWebinarColors = () => {
  const roomDesign = useRoomDesign()
  const { data: brandColors } = useListBrandTokensQuery('color')

  const colors = roomDesign?.colors ?? {
    accent: '#1EC95B',
    sidebar: '#282A29',
    tabs: '#323433',
    background: '#000000',
  }
  let accentColor = colors.accent
  let sidebarColor = colors.sidebar
  let tabsColor = colors.tabs
  let backgroundColor = colors.background

  if (accentColor.startsWith(BRAND_COLOR_TOKEN_PREFIX)) {
    const brandColor = brandColors?.find(
      (c) => c.key === accentColor.substring(BRAND_COLOR_TOKEN_PREFIX.length)
    )
    if (brandColor) {
      accentColor = brandColor.value
    } else {
      accentColor = '#1EC95B'
    }
  }

  if (sidebarColor.startsWith(BRAND_COLOR_TOKEN_PREFIX)) {
    const brandColor = brandColors?.find(
      (c) => c.key === sidebarColor.substring(BRAND_COLOR_TOKEN_PREFIX.length)
    )
    if (brandColor) {
      sidebarColor = brandColor.value
    } else {
      sidebarColor = '#282A29'
    }
  }

  if (tabsColor.startsWith(BRAND_COLOR_TOKEN_PREFIX)) {
    const brandColor = brandColors?.find(
      (c) => c.key === tabsColor.substring(BRAND_COLOR_TOKEN_PREFIX.length)
    )
    if (brandColor) {
      tabsColor = brandColor.value
    } else {
      tabsColor = '#323433'
    }
  }

  if (backgroundColor.startsWith(BRAND_COLOR_TOKEN_PREFIX)) {
    const brandColor = brandColors?.find(
      (c) =>
        c.key === backgroundColor.substring(BRAND_COLOR_TOKEN_PREFIX.length)
    )
    if (brandColor) {
      backgroundColor = brandColor.value
    } else {
      backgroundColor = '#000000'
    }
  }

  const sidebar = ContrastColor.of(sidebarColor, backgroundColor)
  const accent = ContrastColor.of(accentColor, sidebarColor)
  const tabs = ContrastColor.of(tabsColor, sidebarColor)
  const background = ContrastColor.of(backgroundColor, backgroundColor)

  return {
    accent,
    sidebar,
    tabs,
    background,
  }
}

export { useWebinarColors }
